import './App.css';
import AppWeather from './weather_comps/appWeather';


function App() {
  return (
    <div className="App">
      <AppWeather />
    </div>
  );
}

export default App;
